module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/stat/chart.component.html
// module id = 938
// module chunks = 0